import script from "./TheGame.vue?vue&type=script&setup=true&lang=js"
export * from "./TheGame.vue?vue&type=script&setup=true&lang=js"

import "./TheGame.vue?vue&type=style&index=0&id=63f13f86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63f13f86"]])

export default __exports__